import { render, staticRenderFns } from "./oauth2-authorize.vue?vue&type=template&id=9292fe08&"
import script from "./oauth2-authorize.vue?vue&type=script&lang=js&"
export * from "./oauth2-authorize.vue?vue&type=script&lang=js&"
import style0 from "./oauth2-authorize.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./oauth2-authorize.vue?vue&type=style&index=1&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports